export default class ReservierungEinbuchungRequest {
  id: string
  bestellart: string
}
